// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import '@sophocles/components/HorizontalDateBox/styles.scss';

import { DatePicker } from '@mui/x-date-pickers';
import classNames from 'classnames';
import { withFormsy } from 'formsy-react';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';
import { getDateFormat } from '@sophocles/utils/formatUtils';

const HorizontalDateBox = props => {
  const [selected, setSelected] = useState(false);

  const user = useSelector(getAuthUserSelector);
  const dateFormat = getDateFormat(user);

  const changeValue = useCallback(
    value => {
      props.setValue(value);
      if (typeof props.onChange === 'function') {
        props.onChange(value);
      }
    },
    [props],
  );

  const focusInput = useCallback(() => {
    setSelected(true);
  }, []);

  const blurInput = useCallback(
    val => {
      if (typeof props.onBlur === 'function') {
        props.onBlur(val);
      }
    },
    [props],
  );

  const {
    rightAlign,
    outerClassName,
    labelClassName,
    inputDivClassName,
    inputClassName,
    showError,
    errorMessage,
    showRequired,
    value,
    name,
    title,
    isValidDate,
    style,
  } = props;

  const outerClass = classNames(outerClassName, {
    'form-group row': !outerClassName,
    error: (showError || showRequired) && !selected,
  });

  const labelClass = classNames(labelClassName, {
    'col-form-label col-xs-3': !labelClassName,
  });

  const inputDivClass = classNames(inputDivClassName, {
    'col-xs-9': !inputDivClassName,
  });

  const inputClass = classNames(inputClassName, {
    'form-control': !inputClassName,
  });

  const errorMsg = (errorMessage ?? showRequired) ? 'This Field is Required' : '';

  return (
    <div className={outerClass} style={style}>
      <label className={labelClass} htmlFor={name}>
        {title}
      </label>
      <div className={inputDivClass}>
        <DatePicker
          value={value}
          onChange={newValue => changeValue(newValue)}
          onBlur={blurInput}
          format={dateFormat}
          slotProps={{
            textField: {
              size: 'small',
              name,
              className: rightAlign ? 'align-right' : '',
              fullWidth: true,
              error: showError || showRequired,
              helperText: errorMsg,
              hiddenLabel: true,
            },
          }}
        />
      </div>
    </div>
  );
};

HorizontalDateBox.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  outerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  showError: PropTypes.bool,
  getErrorMessage: PropTypes.func,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  showRequired: PropTypes.bool,
  labelClassName: PropTypes.string,
  inputDivClassName: PropTypes.string,
  isValidDate: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  rightAlign: PropTypes.bool,
  style: PropTypes.object,
};

export default withFormsy(HorizontalDateBox);
